import { formatQuery } from '../../../utils/searchQuery';
import { formatDateQuery } from './format-date-query';

export const handleSearch = ({
  activity,
  location,
  datetime,
  filterQuery,
  currentLocale
}) => {
  const urlPrefix = currentLocale?.url_prefix
    ? `/${currentLocale.url_prefix}`
    : '';

  const searchQuery = formatQuery({
    a: activity.value.id,
    ...location.query
  });

  // Extract place_id before lowercasing to preserve case-sensitivity
  const placeIdMatch = searchQuery.match(/place_id=([^&]*)/);
  const placeIdParam = placeIdMatch ? `&place_id=${placeIdMatch[1]}` : '';
  const queryWithoutPlaceId = searchQuery.replace(/&?place_id=[^&]*/, '');

  const dateQuery = datetime
    ? formatDateQuery(datetime.startDate, datetime.endDate, location)
    : '';
  window.location.href = `${urlPrefix}/s/?${queryWithoutPlaceId.toLowerCase()}${dateQuery}${filterQuery}${placeIdParam}`;
};
